import Vue from 'vue'
import Vuex from 'vuex'
import VueRouter from 'vue-router'
import VuePageTransition from 'vue-page-transition'

// Libraries
import VueTyperPlugin from 'vue-typer'
import VueCarousel from 'vue-carousel';

// Pages
import App from './pages/App'
import Welcome from './pages/Welcome'
import WhatWeDo from './pages/WhatWeDo'
import OurCostumers from './pages/OurCostumers'
import Menu from './pages/Menu'
import Projects from './pages/Projects'
import CustomerMain from './pages/CustomersComponents/CustomerMain'
import ProjectCover from './pages/ProjectsCovers/ProjectCover'
import projectsData from './projectsData'
import workersData from './workersData'
import jobsData from './jobsData'
import WhoAreWe from './pages/WhoAreWe'
import Contact from './pages/Contact'
import Career from './pages/Career'
import axios from 'axios'
import VueAxios from 'vue-axios'
import BootstrapVue from 'bootstrap-vue'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'


Vue.use(Vuex);
Vue.use(VueRouter);
Vue.use(VueTyperPlugin);
Vue.use(VueCarousel);
Vue.use(VuePageTransition);
Vue.use(VueAxios, axios)
Vue.use(BootstrapVue)

//Vue.use(VueReCaptcha, { siteKey:'6LfMhawUAAAAAJEJ0uvkUqbdFM5yv5-eHK7E8RWf'})


window.projectsData = projectsData;
window.workersData = workersData;
window.jobsData = jobsData;
Vue.config.productionTip = false;

const routes = [
  {
    path: '/',
    name: Welcome,
    component: Welcome,
    meta: {
      title: 'Welcome :: Hippotec',
      metaTags: [
        {
          name: 'description',
          content: 'The home page of our hippotec app.'
        },
        {
          property: 'og:description',
          content: 'The home page of our hippotec app.'
        }
      ]
    }
  },
  {
    path: '/what-we-do',
    name: WhatWeDo,
    component: WhatWeDo,
    meta: {
      title: 'What We Do',
      transition: 'fade-in-left'
    }
  },
  {
    path: '/our-customers',
    name: OurCostumers,
    component: OurCostumers,
    meta: {
      title: 'Our Customers',
      transition: 'fade-in-left'
    }
  },
  {
    path: '/site-menu',
    name: Menu,
    component: Menu,
    meta: {
      title: 'Site Menu',
      transition: 'fade-in-left'

  }
  },
  {
    path: '/projects',
    name: Projects,
    component: Projects,
    meta: {
      title: 'Projects',
      transition: 'fade-in-left'

    }
  },
  {
    path: '/details/:id',
    name: 'CustomerMain',
    component: CustomerMain,
    props: true,
    meta: {
      title: 'Project Details',
      transition: 'fade-in-left'

    }
  },
  {
    path: '/cover/:id',
    name: 'ProjectCover',
    component: ProjectCover,
    meta: {
      title: 'Project',
      transition: 'fade-in-left'

    }
  },
  {
    path: '/whoarewe',
    name: 'WhoAreWe',
    component: WhoAreWe,
    meta: {
      title: 'Who Are We?',
      transition: 'fade-in-left'

    }
  },
  {
    path: '/contactus',
    name: 'ContactUs',
    component: Contact,
    meta: {
      title: 'Contact us',
      transition: 'fade-in-left'

    }
  },
  {
    path: '/career',
    name: 'Career',
    component: Career,
    meta: {
      title: 'Career',
      transition: 'fade-in-left'

    }
  },
  {
    path: '/*',
    redirect: '/'
  }
];

const router = new VueRouter({routes, mode: 'history',
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
}});

router.beforeEach((to, from, next) => {

  // console.log(to);
  // console.log(from);
  // console.log(next);

  // This goes through the matched routes from last to first, finding the closest route with a title.
  // eg. if we have /some/deep/nested/route and /some, /deep, and /nested have titles, nested's will be chosen.
  const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title);

  // Find the nearest route element with meta tags.
  const nearestWithMeta = to.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);
  // const previousNearestWithMeta = from.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);

  // If a route with a title was found, set the document (page) title to that value.
  if (nearestWithTitle) document.title = nearestWithTitle.meta.title;

  // Remove any stale meta tags from the document using the key attribute we set below.
  Array.from(document.querySelectorAll('[data-vue-router-controlled]')).map(el => el.parentNode.removeChild(el));

  // Skip rendering meta tags if there are none.
  if (!nearestWithMeta) return next();

  // Turn the meta tag definitions into actual elements in the head.
  nearestWithMeta.meta.metaTags.map(tagDef => {

    const tag = document.createElement('meta');

    Object.keys(tagDef).forEach(key => {
      tag.setAttribute(key, tagDef[key]);
    });

    // We use this to track which meta tags we create, so we don't interfere with other ones.
    tag.setAttribute('data-vue-router-controlled', '');

    return tag;

  })

  // Add the meta tags to the document head.
    .forEach(tag => document.head.appendChild(tag));

  next();

});

new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: {App}
});



// WEBPACK FOOTER //
// ./src/main.js